import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'

// actions
import {
  getContactsBreakdown,
  statusType
} from '../../actions'

// components
import { Banner } from '../../components'
import { Breakdown } from './components'

import './dashboard.page.scss'

/**
 * Dashboard Page
 */
class DashboardPage extends Component {
  /**
   * Component did mount
   */
  componentDidMount () {
    const { getBreakdown } = this.props
    getBreakdown()
  }

  /**
   * Render Dashboard
   * @returns {*}
   */
  render () {
    const { breakdown } = this.props
    return (
      <div className='dashboard-page'>
        <Banner
          title='Dashboard'
          icon='q4i-dashboard-2pt' />

        <div className='dashboard-page_cards'>

          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Breakdown
                isLoading={breakdown.status === statusType.IN_PROGRESS}
                data={breakdown.data} />
            </Grid>
          </Grid>
        </div>

      </div>
    )
  }
}

DashboardPage.propTypes = {
  breakdown: PropTypes.object
}

DashboardPage.defaultProps = {
  breakdown: {}
}

const mapStateToProps = (state) => {
  return {
    breakdown: state.dashboard.breakdown
  }
}

const mapDispatchToProps = (dispatch) => ({
  getBreakdown: bindActionCreators(getContactsBreakdown, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage)
